const CHUNK_ERROR_PATTERN =
  /failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed|loading chunk [\w-]+ failed/i;

const RELOAD_SESSION_KEY = 'chunkLoadReloadAt';
const RELOAD_COOLDOWN_MS = 10000;

export class ChunkLoadingExtensions {
  static isChunkLoadError(error: unknown): boolean {
    const message =
      (error as { message?: string } | null)?.message ?? String(error ?? '');
    return CHUNK_ERROR_PATTERN.test(message);
  }

  /**
   * Se o erro for uma falha de import dinâmico (chunk removido por um deploy mais recente),
   * força um reload completo para buscar o shell/chunks atuais. Protegido contra loop por um
   * cooldown em sessionStorage: se já tentou recentemente e o erro persistiu, desiste e deixa
   * o tratamento de erro padrão assumir.
   */
  static recoverIfChunkLoadError(error: unknown): boolean {
    if (typeof window === 'undefined') return false;
    if (!this.isChunkLoadError(error)) return false;

    const lastAttempt = Number(sessionStorage.getItem(RELOAD_SESSION_KEY) ?? 0);
    if (Date.now() - lastAttempt < RELOAD_COOLDOWN_MS) return false;

    sessionStorage.setItem(RELOAD_SESSION_KEY, String(Date.now()));
    window.location.reload();
    return true;
  }
}
